import React from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import { Translation } from 'react-i18next'
import {
  GenerateInputRows,
  getWatchFields,
  getMaxVat,
  calculateSum,
  GenerateGroupInvoiceRows,
  getWatchGroupFields,
  calculateRemain
} from './invoiceInputTable.component'
import { WatchField, useWatch } from '../../form'
import { invoiceRowDefaultValues } from './invoiceForm.component'
import SumField from './sumField.component'
import classNames from 'classnames'
import { Field } from '../../form'
import CustomIconTooltip from '../../utils/CustomIconTooltip'
import { getInvoiceUserEmail } from '../../actions'

const styles = (theme) => ({
  root: {
    width: '100%'
  },
  info: {
    fontWeight: 'bold',
    fontSize: '13px',
    color: 'black',
    padding: '0px 8px 16px 8px',
    display: 'flex'
  },
  button: {
    width: '100%'
  },
  groupInvButton: {
    marginBottom: 20
  },
  disabledTextField: {
    marginTop: theme.spacing(3),
    fontSize: '13px',
    color: 'black',
    marginLeft: '-8px',
    fontWeight: 'bold'
  },
  textField: {
    marginTop: theme.spacing(4),
    border: '1px solid gray'
  },
  resize: {
    fontSize: '14px'
  },
  switch: {
    position: 'relative',
    marginLeft: '10px',
    fontSize: '15px',
    fontWeight: 'bold',
    color: '#808080'
  },
  groupInv: {
    marginTop: theme.spacing(4),
    borderRadius: '2px'
  },
  groupInvoiceInformation: {
    padding: 10
  },
  groupInvExpand: {
    display: 'flex',
    [theme.breakpoints.down('350')]: {
      display: 'block'
    }
  },
  groupInvoiceItem: {
    paddingRight: '30px',
    [theme.breakpoints.down('350')]: {
      paddingRight: '0px'
    }
  },
  buttonContainer: {
    position: 'relative',
    marginTop: '20px',
    textAlign: 'right'
  }
})

const InvoiceInputMobile = ({
  classes,
  fields,
  addRow,
  removeRow,
  setValue,
  control,
  clearErrors,
  getValues,
  shouldDisableVat0,
  groupInvoiceFields,
  addGroupInvoiceRow,
  removeGroupInvoiceRow,
  groupEmailCount,
  totalInvoiceInputSum,
  groupTotalAmount,
  isExpenseAllowanceRow,
  calculateGroupRowAmount,
  isQuickPay,
  resetGroupInvoice,
  isGroupAmountEmpty
}) => {
  const dispatch = useDispatch()
  const watchFields = getWatchFields(
    fields,
    'sum_tax_free',
    'sum_with_vat',
    'vat_percent'
  )
  const watchGroupFields = getWatchGroupFields(
    groupInvoiceFields,
    'groupAmount'
  )
  const hasAllowanceRow = watchFields.hasAllowanceRow

  const vats = useWatch({
    fields: watchFields.vat,
    control: control,
    disabled: !hasAllowanceRow
  })

  const groupInvoiceCheck = useWatch({
    fields: 'groupInvoice',
    control: control
  })

  const addCostCheck = useWatch({
    fields: 'addCost',
    control: control
  })
  const addAllowanceCheck = useWatch({
    fields: 'addAllowance',
    control: control
  })
  const addWorkshiftJournalCheck = useWatch({
    fields: 'addWorkshiftJournal',
    control: control
  })

  const vat_selection = useWatch({
    fields: 'vat_selection',
    control: control
  })

  const _addRow = () => {
    const values = { ...invoiceRowDefaultValues }
    if (vat_selection.vat_selection === 'building_service') {
      values.vat_percent = 0
    }
    values.vat_percent = vat_selection.vat_selection
    addRow(values)
    clearErrors('rows')
  }

  const _removeRow = (index) => {
    removeRow(index)
    clearErrors('rows')
  }

  const handleCheckGroupInvoice = (e) => {
    const isChecked = e.target.checked

    if (isChecked) {
      dispatch(getInvoiceUserEmail(0))
      calculateGroupRowAmount()
    } else {
      resetGroupInvoice()
    }
  }

  return (
    <Translation>
      {(t) => {
        return (
          <div className="panel-body pd-0">
            <div className={classes.root}>
              <GenerateInputRows
                fields={fields}
                remove={_removeRow}
                setValue={setValue}
                getValues={getValues}
                control={control}
                maxVat={getMaxVat(
                  Object.values(vats),
                  hasAllowanceRow,
                  vat_selection.vat_selection === 'building_service'
                    ? true
                    : false
                )}
                shouldDisableVat0={shouldDisableVat0}
              />
              <div className="panel-body">
                <div className={classes.info}>
                  <WatchField fields={watchFields.sum} control={control}>
                    {(fields) => (
                      <SumField
                        name="sum"
                        label={t('invoice.totalTaxFree')}
                        className={classes.disabledTextField}
                        control={control}
                        disabled={true}
                        disableUnderline
                        watchValue={calculateSum(fields)}
                        setValue={setValue}
                        labelStyle={{
                          color: 'black',
                          fontSize: '13px',
                          fontWeight: 'bold',
                          lineHeight: '1.2em',
                          marginTop: '18px'
                        }}
                      />
                    )}
                  </WatchField>
                  <WatchField fields={watchFields.totalSum} control={control}>
                    {(fields) => (
                      <SumField
                        name="total_sum"
                        label={t('invoice.totalWithTax')}
                        className={classes.disabledTextField}
                        control={control}
                        disabled={true}
                        disableUnderline
                        watchValue={calculateSum(fields)}
                        setValue={setValue}
                        labelStyle={{
                          color: 'black',
                          fontSize: '13px',
                          fontWeight: 'bold',
                          marginTop: '19px'
                        }}
                      />
                    )}
                  </WatchField>
                </div>
                <Button
                  variant="contained"
                  className={classes.button}
                  onClick={_addRow}
                >
                  {t('invoice.button6')}
                </Button>
              </div>
            </div>
            {/*KAS-459 Group invoice*/}
            <div
              className={classNames(classes.groupInv, classes.resize)}
              style={{ display: 'block', clear: 'both' }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                  <Field
                    name="groupInvoice"
                    label={t('groupInv.title')}
                    inputType="switch"
                    control={control}
                    className={classes.switch}
                    onChange={(e) => handleCheckGroupInvoice(e)}
                    disabled={
                      isQuickPay ||
                      isExpenseAllowanceRow ||
                      addCostCheck.addCost ||
                      addAllowanceCheck.addAllowance ||
                      addWorkshiftJournalCheck.addWorkshiftJournal
                        ? true
                        : false
                    }
                  />
                  <div style={{ marginLeft: '8px', marginTop: '4px' }}>
                    <CustomIconTooltip
                      info={t('groupInv.info', { returnObjects: true })}
                    />
                  </div>
                </div>
              </div>
              {!isExpenseAllowanceRow && groupInvoiceCheck.groupInvoice ? (
                <div style={{ padding: '8px', overflowX: 'auto' }}>
                  <GenerateGroupInvoiceRows
                    groupInvoiceFields={groupInvoiceFields}
                    remove={removeGroupInvoiceRow}
                    setValue={setValue}
                    getValues={getValues}
                    control={control}
                    t={t}
                  />
                  <div>
                    <WatchField
                      fields={watchGroupFields.groupAmount}
                      control={control}
                    >
                      {(fields) => (
                        <SumField
                          name="groupTotalAmount"
                          label={t('groupInv.label5')}
                          className={classes.disabledTextField}
                          control={control}
                          disabled={true}
                          disableUnderline
                          watchValue={calculateSum(fields)}
                          setValue={setValue}
                          labelStyle={{
                            color: 'black',
                            fontSize: '13px',
                            fontWeight: 'bold'
                          }}
                        />
                      )}
                    </WatchField>
                  </div>
                  <div>
                    <WatchField
                      fields={['groupTotalAmount', 'total_sum']}
                      control={control}
                    >
                      {(fields) => (
                        <SumField
                          name="groupRemainAmount"
                          label={t('groupInv.label6')}
                          className={classes.disabledTextField}
                          control={control}
                          disabled={true}
                          disableUnderline
                          watchValue={calculateRemain(
                            fields.groupTotalAmount,
                            fields.total_sum
                          )}
                          setValue={setValue}
                          labelStyle={{
                            color: 'black',
                            fontSize: '13px',
                            marginTop: '16px',
                            fontWeight: 'bold'
                          }}
                        />
                      )}
                    </WatchField>
                  </div>

                  <div className={classes.buttonContainer}>
                    <Button
                      variant="outlined"
                      className={classNames(
                        classes.button,
                        classes.groupInvButton
                      )}
                      onClick={addGroupInvoiceRow}
                      disabled={
                        groupEmailCount >= 5 ||
                        groupTotalAmount >= totalInvoiceInputSum
                      }
                    >
                      {t('groupInv.btn')}
                    </Button>
                    <Button
                      variant="contained"
                      className={classNames(
                        classes.button,
                        classes.groupInvButton
                      )}
                      onClick={calculateGroupRowAmount}
                      disabled={isGroupAmountEmpty}
                    >
                      {t('groupInv.calculateBtn')}
                    </Button>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        )
      }}
    </Translation>
  )
}

InvoiceInputMobile.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(InvoiceInputMobile)
